import { CapoPlugin } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];